/**
 * GAU cart confetti.
 * Celebrates (once per milestone) when the cart reaches FREE SHIPPING and when it reaches the FREE GIFT tier.
 *  - Only runs inside the cart (cart drawer or cart page), never on the rest of the site.
 *  - Reads the progress bar (snippets/gau-cart-bar.liquid): dots marked data-gcx-stage="ship" / "gift" get
 *    the class "is-on" when reached. Fires only when a milestone changes from not-reached to reached,
 *    never just because the cart was opened or the page loaded with the milestone already reached.
 *  - One lightweight <canvas> that is created at the start, removed at the end (about 3 seconds), and
 *    skipped completely when the visitor has "reduce motion" turned on.
 *
 * EDIT HERE: size, colours and speed.
 */
(function () {
  if (window.__gauConfetti) return;
  window.__gauConfetti = true;

  var COLORS = ['#3E8E45', '#51BA69', '#F2C94C', '#E4A11B', '#54331C', '#0F6B35', '#F7E39A'];
  var PER_CANNON_DESKTOP = 70; // particles from each side cannon (desktop)
  var PER_CANNON_MOBILE = 50; // same, on phones
  var RAIN = 34; // extra pieces falling from the top
  var GRAVITY = 0.34; // higher = falls faster
  var LIFE_MIN = 95; // frames (60 per second), so about 1.6 s
  var LIFE_MAX = 165; // about 2.8 s

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var prev = null; // last seen state { ship, gift }
  var pending = null; // celebrations waiting for the cart to be visible
  var pollTimer = 0;
  var pollUntil = 0;
  var debounceTimer = 0;

  var host = null;
  var hostPos = '';
  var canvas = null;
  var ctx = null;
  var parts = [];
  var raf = 0;
  var lastT = 0;
  var W = 0;
  var H = 0;
  var dpr = 1;
  var killTimer = 0;

  function stages() {
    if (!document.querySelector('[data-gau-bar]')) return null;
    return {
      ship: !!document.querySelector('[data-gau-bar] [data-gcx-stage="ship"].is-on'),
      gift: !!document.querySelector('[data-gau-bar] [data-gcx-stage="gift"].is-on'),
    };
  }

  function visibleBar() {
    var bars = document.querySelectorAll('[data-gau-bar]');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].offsetWidth && bars[i].getClientRects().length) return bars[i];
    }
    return null;
  }

  function check() {
    var s = stages();
    if (!prev) {
      prev = s || { ship: false, gift: false };
      return;
    }
    if (!s) return; // cart empty or bar not drawn right now: keep the last known state
    if (s.ship && !prev.ship) pending = Object.assign(pending || {}, { ship: true });
    if (s.gift && !prev.gift) pending = Object.assign(pending || {}, { gift: true });
    if (pending) {
      if (!s.ship) pending.ship = false;
      if (!s.gift) pending.gift = false;
    }
    prev = s;
    tryFire();
  }

  function stopPoll() {
    if (pollTimer) clearInterval(pollTimer);
    pollTimer = 0;
  }

  function startPoll() {
    if (pollTimer) return;
    pollUntil = Date.now() + 10000;
    pollTimer = setInterval(function () {
      if (Date.now() > pollUntil) {
        stopPoll();
        pending = null;
        return;
      }
      tryFire();
    }, 300);
  }

  function tryFire() {
    if (!pending || (!pending.ship && !pending.gift)) {
      pending = null;
      stopPoll();
      return;
    }
    if (document.hidden || !visibleBar()) {
      startPoll(); // cart drawer is still closed or opening: wait for it
      return;
    }
    stopPoll();
    var strength = pending.ship && pending.gift ? 1.5 : 1;
    pending = null;
    setTimeout(function () {
      var bar = visibleBar();
      if (bar) launch(bar, strength);
    }, 350); // let the drawer finish sliding in
  }

  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(check, 150);
  }

  function setup(bar) {
    var c = bar.closest('dialog') || bar.closest('.cart-page') || bar.parentElement;
    if (!c) return false;
    if (host !== c) cleanup();
    host = c;
    if (!canvas) {
      hostPos = c.style.position;
      if (window.getComputedStyle(c).position === 'static') c.style.position = 'relative';
      canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText =
        'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
      c.appendChild(canvas);
      ctx = canvas.getContext('2d');
      if (!ctx) {
        cleanup();
        return false;
      }
    }
    var r = c.getBoundingClientRect();
    W = Math.max(1, Math.round(r.width));
    H = Math.max(1, Math.round(r.height));
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    return true;
  }

  function rnd(a, b) {
    return a + Math.random() * (b - a);
  }

  function spawn(bar, k) {
    if (!host || !canvas) return;
    var r = host.getBoundingClientRect();
    var br = bar.getBoundingClientRect();
    var oy = Math.min(H * 0.5, Math.max(0, br.bottom - r.top + 30)); // start just under the progress bar
    var per = Math.round((window.innerWidth < 750 ? PER_CANNON_MOBILE : PER_CANNON_DESKTOP) * k);
    var i;
    for (i = 0; i < per * 2; i++) {
      var left = i % 2 === 0;
      var a = (rnd(52, 82) * Math.PI) / 180;
      var sp = rnd(7, 15);
      parts.push(piece(left ? W * 0.08 : W * 0.92, oy, (left ? 1 : -1) * Math.cos(a) * sp, -Math.sin(a) * sp));
    }
    var rain = Math.round(RAIN * k);
    for (i = 0; i < rain; i++) {
      parts.push(piece(rnd(0, W), rnd(-60, -8), rnd(-1.2, 1.2), rnd(1, 3.2)));
    }
  }

  function piece(x, y, vx, vy) {
    return {
      x: x,
      y: y,
      vx: vx,
      vy: vy,
      w: rnd(6, 11),
      h: rnd(3.5, 6),
      rot: rnd(0, 6.28),
      vr: rnd(-0.25, 0.25),
      wob: rnd(0, 6.28),
      wobS: rnd(0.08, 0.22),
      color: COLORS[(Math.random() * COLORS.length) | 0],
      round: Math.random() < 0.22,
      life: rnd(LIFE_MIN, LIFE_MAX),
      age: 0,
    };
  }

  function launch(bar, k) {
    if (reduce) return;
    if (!setup(bar)) return;
    spawn(bar, k);
    setTimeout(function () {
      if (canvas && host && document.contains(bar)) spawn(bar, k * 0.5);
    }, 380);
    clearTimeout(killTimer);
    killTimer = setTimeout(cleanup, 5200); // safety net
    if (!raf) {
      lastT = 0;
      raf = requestAnimationFrame(frame);
    }
  }

  function frame(t) {
    raf = 0;
    if (!canvas || !ctx) return;
    var dt = lastT ? Math.min((t - lastT) / 16.667, 2.5) : 1;
    lastT = t;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var drag = Math.pow(0.985, dt);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.age += dt;
      p.vx *= drag;
      p.vy = (p.vy + GRAVITY * dt) * Math.pow(0.992, dt);
      p.wob += p.wobS * dt;
      p.x += (p.vx + Math.sin(p.wob) * 0.7) * dt;
      p.y += p.vy * dt;
      p.rot += p.vr * dt;
      if (p.age >= p.life || p.y > H + 24) {
        parts.splice(i, 1);
        continue;
      }
      var fadeStart = p.life * 0.65;
      ctx.globalAlpha = p.age > fadeStart ? Math.max(0, 1 - (p.age - fadeStart) / (p.life - fadeStart)) : 1;
      var cs = Math.cos(p.rot) * dpr;
      var sn = Math.sin(p.rot) * dpr;
      var flip = Math.cos(p.wob);
      ctx.setTransform(cs, sn, -sn * flip, cs * flip, p.x * dpr, p.y * dpr);
      ctx.fillStyle = p.color;
      if (p.round) {
        ctx.beginPath();
        ctx.arc(0, 0, p.h * 0.7, 0, 6.2832);
        ctx.fill();
      } else {
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      }
    }
    if (parts.length) raf = requestAnimationFrame(frame);
    else cleanup();
  }

  function cleanup() {
    clearTimeout(killTimer);
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
    parts = [];
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    if (host && hostPos !== null) host.style.position = hostPos;
    canvas = null;
    ctx = null;
    host = null;
  }

  function init() {
    check(); // remember where the cart is right now, without celebrating it
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        var t = m.target;
        if (t && t.nodeType === 1 && t.closest && t.closest('cart-items-component,[data-gau-bar],.cart-page')) {
          schedule();
          return;
        }
        if (m.addedNodes) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1 && (n.matches('[data-gau-bar]') || n.querySelector('[data-gau-bar]'))) {
              schedule();
              return;
            }
          }
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();